require('./expensesByCategoryView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const {
    PureComponent
} = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const moment = require('moment');

// @components
import { ExpensesByCategoryMonthly } from 'components/expenses/expensesByCategoryMonthly/expensesByCategoryMonthly'
import { ExpensesByCategoryHistogram } from 'components/expenses/expensesByCategoryHistogram/expensesByCategoryHistogram'
import { withRouter } from 'react-router-dom';
const ExpensesByCategoryInfo = require('./expensesByCategoryInfo/expensesByCategoryInfo');
const ExpensesByCategoryTable = require('./expensesByCategoryTable/expensesByCategoryTable');
const ExpensesByCategoryFilter = require('./expensesByCategoryFilter/expensesByCategoryFilter');
const ExpensesByCategoryFilterApplied = require('./expensesByCategoryFilterApplied/expensesByCategoryFilterApplied');
const ExpensesByCategoryTabs = require('./expensesByCategoryTabs/expensesByCategoryTabs');
const { AggregatorBeta } = require('components/aggregator/aggregatorBeta/aggregatorBeta');

// @commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @actions
const expensesActions = require('actions/globalPositionExpensesOld');

// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

import { getBanksOptions } from 'selectors/aggregator';

// @constants
const { categoriesList } = require('constants/categories');
const MAX_EXPENSES_BY_CATEGORY = 20;
const { EURO_TEXT, ACCOUNT_INTERVENTION_OWNER, CARD_INTERVENTION_OWNER } = require('constants/index');

const {
    DATE_FORMAT_API
} = require('constants/index');

class ExpensesByCategoryViewOld extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            category: this.props.match.params.category === 'all-categories' ? '' : this.props.match.params.category,
            categoryHistogram: this.props.match.params.category,
            filterSettingsOpen: false,
            totalExpensesMonth: this.props.totalExpenses,
            itemsToShow: MAX_EXPENSES_BY_CATEGORY,
            showMore: false,
            creditSelected: true,
            debitSelected: true,
            filterDateChange: false,
            filterTypeChange: false,
            showSubcategories: true,
            bank: !this.props.bankOptions || this.props.bankOptions.size > 1 ? null : this.props.bankOptions.first().get('value'),
            changeTabs: false
        }

        this.setFilter = this.setFilter.bind(this);
        this.buildAccounts = this.buildAccounts.bind(this);
        this.buildCards = this.buildCards.bind(this);
        this.getTotalMontoCategory = this.getTotalMontoCategory.bind(this);
        this.handleChangePeriodHistogram = this.handleChangePeriodHistogram.bind(this);
        this.handleClearFilter = this.handleClearFilter.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.createContents = this.createContents.bind(this);
        this.receiveDataFromServer = this.receiveDataFromServer.bind(this);
        this.handleChangeCategory = this.handleChangeCategory.bind(this);
        this.handleShowMoreExpenses = this.handleShowMoreExpenses.bind(this);
        this.handleChangeCategoryHistogram = this.handleChangeCategoryHistogram.bind(this);
        this.handleContractType = this.handleContractType.bind(this);
        this.getDefaultCategory = this.getDefaultCategory.bind(this);
        this.handleRemoveCategory = this.handleRemoveCategory.bind(this);
    }

    componentDidMount() {
        // This is necessary because if the page is reloaded, the total
        // expenses are lost.
        const { otherBanksView, bankOptions } = this.props
        const { bank } = this.state

        const banks = otherBanksView && !bank ?
            bankOptions.map(b => b.get('value')).toJS() :
            (!bank ? null : [bank])

        this.props.expensesActions.requestExpenses(true, undefined, undefined, banks);
        this.props.expensesActions.requestHistogramExpenses(
            'bank',
            `${this.state.category === 'all-categories' ? this.getDefaultCategory() : this.state.category}`,
            undefined,
            undefined,
            this.props.match.params.accountType,
            this.props.match.params.cardType,
            banks
        ); // Function to get months and days total expenses
        this.props.expensesActions.requestMonthlyExpenses(banks); // Function to get monthly expenses
        this.props.expensesActions.requestExpensesByCategory(
            `${this.state.category === '' ? this.getDefaultCategory() : this.state.category}`,
            this.props.match.params.accountType,
            this.props.match.params.cardType,
            banks
        );
    }


    componentWillReceiveProps(nextProps) {
        const { otherBanksView, bankOptions } = this.props
        const banks = otherBanksView ? bankOptions.map(b => b.get('value')).toJS() : null;

        if (this.state.category !== this.getDefaultCategory() && !this.state.changeTabs) {
            this.setState({
                category: this.getDefaultCategory(),
            });

            this.props.expensesActions.requestExpensesByCategory(
                this.getDefaultCategory(),
                this.props.match.params.accountType,
                this.props.match.params.cardType,
                banks
            );
        }

        if (nextProps.expensesByCategory.size > MAX_EXPENSES_BY_CATEGORY) {
            this.setState({
                showMore: true,
                totalExpensesMonth: nextProps.totalExpenses,
            });
        } else {
            this.setState({
                showMore: false,
                totalExpensesMonth: nextProps.totalExpenses,
            });
        }
    }

    componentWillUnmount() {
        this.props.expensesActions.resetHistogram();
        this.props.expensesActions.resetCategories();
    }

    getDefaultCategory() {
        const { totalCategoryExpenses, totalPreviousExpensesByCategory } = this.props;
        const categoriesListSorted = this.sortCategories(categoriesList, totalCategoryExpenses, totalPreviousExpensesByCategory)[0];
        return (categoriesListSorted);
    }

    handleChangeCategory(category, type) {
        const { immFilters, otherBanksView, bankOptions } = this.props;
        const { filterDateChange, filterTypeChange, bank } = this.state

        let banks = null
        if (otherBanksView)
            banks = !bank ? bankOptions.map(b => b.get('value')).toJS() : [bank]


        if (category !== this.state.category && category !== '') {
            this.setState({
                category,
                categoryHistogram: category,
                changeTabs: true
            }, () => this.props.expensesActions.updateFiltersByCategory(category, immFilters.toJS(), banks));
        } else {
            this.setState({
                categoryHistogram: category
            });
        }
        const typeCard = type === undefined ? immFilters.getIn(['groupContract', 'value']) : type;
        this.props.expensesActions.requestHistogramExpenses(
            'category',
            category,
            filterDateChange ? immFilters.getIn(['date', 'from']) : undefined,
            filterDateChange ? immFilters.getIn(['date', 'to']) : undefined,
            filterTypeChange ? immFilters.getIn(['typeAccount', 'value']) : undefined,
            typeCard,
            banks
        );
    }

    handleShowMoreExpenses() {
        const { expensesByCategory } = this.props;
        const itemsToShow = this.state.itemsToShow + MAX_EXPENSES_BY_CATEGORY;

        this.setState({
            itemsToShow,
            showMore: itemsToShow < expensesByCategory.size
        });
    }

    updateContractItem(item, optionalItemValue) {
        const sameName = item.name === optionalItemValue.name;
        const sameNumber = item.number === optionalItemValue.number;
        return Object.assign(item, {
            selected: !!item.selected ? !(sameName && sameNumber) : false
        });
    }

    handleRemoveCategory(categoryKey, optionalItemValue) {
        const { immFilters } = this.props;
        const today = moment().startOf('day');

        const beginningOfTime = moment()
            .subtract(11, 'months')
            .startOf('month');

        let filters = immFilters.toJS();

        if (categoryKey === 'date') {
            Object.assign(filters.date, {
                from: beginningOfTime,
                isActive: false,
                selected: 'None',
                to: today
            });
        }

        if (categoryKey === 'contract') {
            Object.assign(filters.contracts, {
                cardsContracts: filters.contracts.cardsContracts
                    .map(item => Object.assign(item, this.updateContractItem(item, optionalItemValue))),
                accountsContracts: filters.contracts.accountsContracts
                    .map(item => Object.assign(item, this.updateContractItem(item, optionalItemValue)))
            });

            let contractsActives = filters.contracts.cardsContracts.filter(item => item.selected).length;
            contractsActives += filters.contracts.accountsContracts.filter(item => item.selected).length;

            if (contractsActives === 0) {
                Object.assign(filters.contracts, {
                    isActive: false,
                    cardsContracts: filters.contracts.cardsContracts
                        .map(item => Object.assign(item, {
                            selected: true
                        })),
                    accountsContracts: filters.contracts.accountsContracts
                        .map(item => Object.assign(item, {
                            selected: true
                        }))
                });
            }
        }

        if (categoryKey === 'subcategory') {
            Object.assign(filters.subcategory, {
                isActive: false,
                subcategory: 'all'
            });
        }

        this.setState({
            filterDateChange: false,
            filterTypeChange: false
        });

        this.setFilter(filters);
    }

    getMoreMovementsButton(show) {
        if (show) {
            return (
                <div className="expenses-by-category__link-container">
                    <div className="expenses-by-category__previous-months">
                        <OKButton modifier="link-complementary" onClick={this.handleShowMoreExpenses}>
                            <FormattedText value="cards-seeMoreMovements" format={__CONTACT_CENTER__ ? 'uppercase' : null} />
                        </OKButton>
                    </div>
                </div>
            );
        }

        return null;
    }

    sortCategories(categories, currentValues, previousValues) {
        let sorted = [];
        let result = categories;

        if (currentValues && previousValues) {
            categories.forEach(category => {
                sorted.push({
                    category,
                    currentValue: currentValues.get(category) || 0,
                    previousValue: previousValues.get(category) || 0
                });
            });

            sorted.sort((a, b) => {
                if (a.currentValue !== b.currentValue) {
                    return b.currentValue - a.currentValue;
                } else {
                    if (a.previousValue !== b.previousValue) {
                        return b.previousValue - a.previousValue;
                    }

                    let aCleaned = a.category.toUpperCase();
                    let bCleaned = b.category.toUpperCase();

                    return (aCleaned < bCleaned) ? -1 : (aCleaned > bCleaned) ? 1 : 0;
                }
            });

            result = sorted.map(item => item.category);
        }

        return result;
    }

    getTotalMontoCategory() {
        const { expensesByCategory } = this.props;
        let totalMonto = 0;
        expensesByCategory.toJS().map(monto => {
            totalMonto += monto !== undefined ? monto.monto : 0;
        })
        return (totalMonto * -1);
    }

    createContents() {
        const { immFilters, expensesByCategory, immAccounts, immCards, currency, otherBanksView } = this.props;

        let movements = expensesByCategory.slice(0, this.state.itemsToShow);

        const totalMovements = expensesByCategory.size;
        const subcategory = immFilters.getIn(['subcategory', 'subcategory']);
        const moreMovementsButton = this.getMoreMovementsButton(this.state.showMore);

        if (subcategory !== 'all') {
            movements = expensesByCategory.filter(expense => expense.get('subCategories') === subcategory).slice(0, this.state.itemsToShow);
        }

        if (movements.size === 0) {
            return (
                <div>
                    <ExpensesByCategoryFilterApplied
                        category={this.state.category}
                        immFilters={immFilters}
                        onClearFilter={this.handleClearFilter}
                        removeFilter={(filterKey, optionalItemValue) => this.handleRemoveCategory(filterKey, optionalItemValue)}
                    />
                    <EmptyState
                        primaryText={formatText('movements-emptyMovements')}
                        withMargin={false}
                        iconType="noitems-banking" />
                </div>
            );
        } else {
            return (
                <div>
                    <ExpensesByCategoryFilterApplied
                        category={this.state.category}
                        immFilters={immFilters}
                        totalMovementsCategory={totalMovements}
                        totalExpensesCategory={this.getTotalMontoCategory()}
                        currency={currency}
                        onClearFilter={this.handleClearFilter}
                        removeFilter={(filterKey, optionalItemValue) => this.handleRemoveCategory(filterKey, optionalItemValue)}
                    />
                    <ExpensesByCategoryTable
                        canChangeCategory={!otherBanksView}
                        expensesByCategory={movements}
                        immAccounts={immAccounts}
                        immCards={immCards}
                    />
                    {moreMovementsButton}
                </div>
            );
        }
    }

    receiveDataFromServer() {
        if (this.props.isPartialFetching) {
            return <LoadingSection />;
        } else {
            return this.createContents();
        }
    }

    handleToggleFilters(showSubcategories) {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen,
            showSubcategories: showSubcategories
        });
    }

    setFilter(filters) {
        const { filterDateChange, bank } = this.state;
        const { otherBanksView, bankOptions } = this.props

        let banks = null
        if (otherBanksView)
            banks = !bank ? bankOptions.map(b => b.get('value')).toJS() : [bank]

        let typeContract = 'both'
        switch (filters.groupContract.value) {
            case "0":
                typeContract = 'debit'
                this.setState({
                    debitSelected: true,
                    creditSelected: false,
                    filterTypeChange: true
                });
                break;
            case "1":
                typeContract = 'credit'
                this.setState({
                    debitSelected: false,
                    creditSelected: true,
                    filterTypeChange: true
                });
                break;
            default:
                typeContract = 'both'
                this.setState({
                    debitSelected: true,
                    creditSelected: true,
                    filterTypeChange: false
                });
        }

        let { from, to, selected } = filters.date;
        let dateIsChangeFilters

        if (selected !== 'None') {
            dateIsChangeFilters = from.format(DATE_FORMAT_API) === moment().startOf('month').format(DATE_FORMAT_API) && to.format(DATE_FORMAT_API) === moment().format(DATE_FORMAT_API);
            dateIsChangeFilters = filterDateChange ? false : dateIsChangeFilters;
        } else {
            dateIsChangeFilters = true;
            this.setState({
                filterDateChange: false
            });
        }

        if (!dateIsChangeFilters) {
            this.setState({
                filterDateChange: true
            });
        }

        this.props.expensesActions.updateFiltersByCategory(this.state.category === '' ? this.getDefaultCategory() : this.state.category, filters, banks);
        this.props.expensesActions.requestHistogramExpenses('type',
            typeContract,
            !dateIsChangeFilters ? from : undefined,
            !dateIsChangeFilters ? to : undefined,
            filters.typeAccount.value,
            undefined,
            banks);
        this.props.expensesActions.requestExpenses(true, filters.typeAccount.value, undefined, banks);
    }

    handleChangePeriodHistogram(period, type) {
        const { immFilters, otherBanksView, bankOptions } = this.props;
        const { filterDateChange, filterTypeChange, bank } = this.state

        let banks = null
        if (otherBanksView)
            banks = !bank ? bankOptions.map(b => b.get('value')).toJS() : [bank]


        this.props.expensesActions.requestHistogramExpenses(
            'period',
            period,
            filterDateChange ? immFilters.getIn(['date', 'from']) : undefined,
            filterDateChange ? immFilters.getIn(['date', 'to']) : undefined,
            filterTypeChange ? immFilters.getIn(['typeAccount', 'value']) : undefined,
            type,
            banks);
    }

    handleChangeCategoryHistogram(categoryHistogram, type) {
        this.handleChangeCategory(categoryHistogram, type);
    }

    handleChangeBankHistogram = (bank, category) => {
        const { immFilters, otherBanksView, bankOptions } = this.props

        let banks = null
        if (otherBanksView)
            banks = !bank ? bankOptions.map(b => b.get('value')).toJS() : [bank]

        this.props.expensesActions.requestExpenses(
            true,
            immFilters.getIn(['typeAccount', 'value']),
            immFilters.getIn(['groupContract', 'value']),
            banks
        );

        this.props.expensesActions.requestHistogramExpenses(
            'bank',
            category,
            undefined, //immFilters.getIn(['date', 'from']),
            undefined, //immFilters.getIn(['date', 'to']),
            immFilters.getIn(['typeAccount', 'value']),
            immFilters.getIn(['groupContract', 'value']),
            banks
        );

        this.props.expensesActions.requestExpensesByCategory(
            this.state.category,
            immFilters.getIn(['typeAccount', 'value']),
            immFilters.getIn(['groupContract', 'value']),
            banks
        );

        this.setState({ bank })
    }

    handleClearFilter() {
        const { immFilters } = this.props;

        const today = moment()
            .startOf('day');

        const beginningOfTime = moment()
            .subtract(11, 'months')
            .startOf('month');

        let filters = immFilters.toJS();

        Object.assign(filters.date, {
            from: beginningOfTime,
            isActive: false,
            selected: 'None',
            to: today
        });

        Object.assign(filters.contracts, {
            isActive: false,
            cardsContracts: filters.contracts.cardsContracts
                .map(item => Object.assign(item, { selected: true })),
            accountsContracts: filters.contracts.accountsContracts
                .map(item => Object.assign(item, { selected: true }))
        });

        Object.assign(filters.subcategory, {
            isActive: false,
            subcategory: 'all'
        });

        Object.assign(filters.groupContract, {
            value: '2',
        });

        Object.assign(filters.typeAccount, {
            value: 'all',
        });

        this.setFilter(filters);
    }

    buildAccounts() {
        let accounts = [];
        const { immAccounts } = this.props;
        immAccounts.forEach(id => {
            const count = id.toJS();
            if (count.balance.currency === EURO_TEXT && count.filters.valid && count.interventionType === ACCOUNT_INTERVENTION_OWNER) {
                accounts.push({
                    name: count.description,
                    number: count.iban,
                    selected: true
                });
            }
        });
        return (accounts);
    }

    buildCards() {
        const { immCards } = this.props;
        let cards = [];
        immCards.forEach(id => {
            const card = id.toJS();
            if (card.filters.valid && card.interventionType === CARD_INTERVENTION_OWNER) {
                cards.push({
                    name: card.alias.current,
                    number: card.number,
                    selected: true
                });
            }
        });
        return (cards);
    }

    handleContractType(type) {
        const { filterDateChange, bank } = this.state;
        const { immFilters, otherBanksView, bankOptions } = this.props;

        let banks = null
        if (otherBanksView)
            banks = !bank ? bankOptions.map(b => b.get('value')).toJS() : [bank]

        this.props.expensesActions.requestHistogramExpenses('type',
            type,
            filterDateChange ? immFilters.getIn(['date', 'from']) : undefined,
            filterDateChange ? immFilters.getIn(['date', 'to']) : undefined,
            null,
            null,
            banks);
        let typeFilter;
        switch (type) {
            case "debit":
                typeFilter = '0'
                this.setState({
                    debitSelected: true,
                    creditSelected: false,
                    filterTypeChange: true
                });
                break;
            case "credit":
                typeFilter = '1'
                this.setState({
                    debitSelected: false,
                    creditSelected: true,
                    filterTypeChange: true
                });
                break;
            case "both":
                typeFilter = '2'
                this.setState({
                    debitSelected: true,
                    creditSelected: true,
                    filterTypeChange: false
                });
                break;
            case "":
                typeFilter = '3'
                this.setState({
                    debitSelected: false,
                    creditSelected: false,
                    filterTypeChange: false
                });
                break;
            default:
                typeFilter = '2'
                this.setState({
                    debitSelected: false,
                    creditSelected: false,
                    filterTypeChange: true
                });
        }
        this.props.expensesActions.requestExpenses(true, immFilters.getIn(['typeAccount', 'value']), typeFilter, banks);
        this.props.expensesActions.requestExpensesByCategory(
            `${this.state.category === '' ? this.getDefaultCategory() : this.state.category}`,
            undefined,
            typeFilter,
            banks
        );
    }

    render() {
        const { flagBasedFeatures, otherBanksView, bankOptions, immFilters, totalExpenses, totalPreviousExpensesByCategory, totalCategoryExpenses, immExpensesHistogram, currency, immMonthlyExpenses, expensesByCategory } = this.props;
        const { debitSelected, creditSelected, filterDateChange, filterSettingsOpen, filterTypeChange, showSubcategories, bank } = this.state;
        const dateFilter = immFilters.getIn(['date', 'isActive']);
        const typeAccountFilter = immFilters.getIn(['typeAccount', 'value']) === 'custom';
        const subcategoryFilter = immFilters.getIn(['subcategory', 'isActive']);
        const isAnyActiveFilter = dateFilter || subcategoryFilter || typeAccountFilter;
        const isAnyActiveFilterHistogram = filterDateChange || filterTypeChange || typeAccountFilter;
        const mappingBreadcrumb = !otherBanksView ?
            [{
                text: formatText('breadcrumb-global'),
                url: '/myprofile/global'
            }, {
                text: formatText('cards-expenses'),
                url: ''
            }] :
            [{
                text: formatText('breadcrumb-global'),
                url: '/myprofile/global'
            }, {
                text: formatText('breadcrumb-otherBanks'),
                url: '/myprofile/global/entities/accounts'
            }, {
                text: formatText('breadcrumb-incomeAndExpenses'),
                url: ''
            }]

        const table = this.receiveDataFromServer();

        const categoriesListSorted = this.sortCategories(categoriesList, totalCategoryExpenses, totalPreviousExpensesByCategory);
        const defaultCategory = categoriesListSorted[0];
        const totalExpensesByCategory = totalCategoryExpenses ? totalCategoryExpenses.get(this.state.category === 'all-categories' ? defaultCategory : this.state.category) : 0;
        const tutorial = !otherBanksView ? null : <AggregatorBeta tooltipTextKey="aggregatorBeta-tooltip" />

        return (
            <div className="expenses-by-category">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle(otherBanksView ? 'otherBanks-expenses' : 'cards-expenses')}
                                tutorial={tutorial}
                            >
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="global-position grid-view--content-position-negative">
                                <div className="col-lg-8 col-md-12 col-sm-12">
                                    <ExpensesByCategoryHistogram
                                        flagBasedFeatures={flagBasedFeatures}
                                        bankOptions={otherBanksView && bankOptions}
                                        histogram={immExpensesHistogram.toJS().histogramData}
                                        lineChart={immExpensesHistogram.toJS().lineData}
                                        filterType={immExpensesHistogram.toJS().filters.type}
                                        onHandleChangePeriodHistogram={this.handleChangePeriodHistogram}
                                        onHandleTypeContract={this.handleContractType}
                                        onHandleChangeCategoryHistogram={this.handleChangeCategoryHistogram}
                                        onHandleChangeBankHistogram={this.handleChangeBankHistogram}
                                        selectedBank={bank}
                                        loading={immExpensesHistogram.toJS().isFetching}
                                        categories={categoriesListSorted}
                                        currency={currency}
                                        selectedCategory={this.state.categoryHistogram}
                                        hasDebit={immExpensesHistogram.toJS().contracts.debit}
                                        hasCredit={immExpensesHistogram.toJS().contracts.credit}
                                        creditSelected={creditSelected}
                                        debitSelected={debitSelected}
                                        blue={otherBanksView}
                                        onOpenFilter={this.handleToggleFilters}
                                        onHandleClearFilter={this.handleClearFilter}
                                        filter={isAnyActiveFilterHistogram}
                                    />
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12 monthly-widget-container">
                                    <ExpensesByCategoryMonthly
                                        monthlyValue={immMonthlyExpenses.get('resultMonthlyExpenses')}
                                        loading={immMonthlyExpenses.get('isFetching')}
                                        currency={currency}
                                        totalExpenses={immMonthlyExpenses.get('totalExpenseCurrentMonth')}
                                    />
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <ExpensesByCategoryTabs
                                    categories={categoriesListSorted}
                                    onChangeCategory={this.handleChangeCategory}
                                    totalExpenses={immExpensesHistogram.get('totalExpensesCustomDate')}
                                    totalCategoryExpenses={totalCategoryExpenses}
                                    selectedTab={this.state.category === '' ? defaultCategory : this.state.category}
                                    blue={otherBanksView}
                                    expensesByCategory={expensesByCategory}

                                />
                                {/**
                                 * @horizontal-scroll
                                 *
                                 * The result table has a container with an horizontal scroll and the
                                 * inner content is set to a fix width according to its size in
                                 * desktop.
                                 */}
                                <ExpensesByCategoryInfo
                                    category={this.state.category === '' ? defaultCategory : this.state.category}
                                    categories={categoriesListSorted}
                                    totalExpenses={totalExpenses}
                                    totalExpensesByCategory={totalExpensesByCategory}
                                    totalCategoryExpenses={totalCategoryExpenses}
                                    onOpenFilter={this.handleToggleFilters}
                                    currency={currency}
                                    filter={isAnyActiveFilter}
                                    onHandleClearFilter={this.handleClearFilter}
                                />
                            </div>
                            <div className="col-xs-12">
                                <div className="expenses-by-category__content">
                                    {table}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ExpensesByCategoryFilter
                    accountId={'accountId'}
                    accountCurrency={'EUR'}
                    setFilter={this.setFilter}
                    immFilter={immFilters}
                    isOpen={filterSettingsOpen}
                    onCloseClick={this.handleToggleFilters}
                    isCredit={false}
                    category={this.state.category === 'all-categories' || this.state.category == '' ? defaultCategory : this.state.category}
                    accounts={this.buildAccounts()}
                    cards={this.buildCards()}
                    showSubcategories={showSubcategories}
                />
            </div>
        );
    }
}

ExpensesByCategoryViewOld.propTypes = {
    immFilters: PropTypes.object,
    match: PropTypes.object,
    immExpensesHistogram: PropTypes.object,
    immMonthlyExpenses: PropTypes.object,
    isPartialFetching: PropTypes.bool,
    expensesByCategory: PropTypes.object,
    expensesActions: PropTypes.object,
    currency: PropTypes.string,
    immAccounts: PropTypes.object,
    immCards: PropTypes.object,
    totalExpenses: PropTypes.number,
    totalPreviousExpenses: PropTypes.number,
    totalPreviousExpensesByCategory: PropTypes.object,
    totalCategoryExpenses: PropTypes.object,
    totalCustomDatesAll: PropTypes.number,
    totalCustomDateExpensesTabs: PropTypes.number,
    otherBanksView: PropTypes.bool,
    bankOptions: PropTypes.object,
    flagBasedFeatures: PropTypes.object,
};

module.exports.constructor = ExpensesByCategoryViewOld;

module.exports.ExpensesByCategoryViewOld = withRouter(connect(
    (state, ownProps) => ({
        flagBasedFeatures: state.flagBasedFeatures,
        bankOptions: ownProps.otherBanksView && getBanksOptions(state),
        immFilters: state.globalPosition.getIn(['expenses', 'filtersByCategory']),
        immExpensesHistogram: state.expensesHistogram,
        immMonthlyExpenses: state.monthlyExpensesIndicator,
        isPartialFetching: state.globalPosition.getIn(['expenses', 'isPartialFetching']),
        expensesByCategory: state.globalPosition.getIn(['expenses', 'expensesByCategory']),
        currency: state.accounts.getIn(['balance', 0, 'currency']),
        immAccounts: state.accounts.get('byId'),
        immCards: state.cards.get('byId'),
        totalExpenses: state.globalPosition.getIn(['expenses', 'expenses', 'currentPeriod', 'total', 'ALL']),
        totalCustomDateExpensesTabs: state.expensesHistogram.get('totalExpensesCustomDate'),
        totalPreviousExpenses: state.globalPosition.getIn(['expenses', 'expenses', 'previousPeriod', 'total', 'ALL']),
        totalPreviousExpensesByCategory: state.globalPosition.getIn(['expenses', 'expenses', 'previousPeriod', 'byCategory', 'ALL']),
        totalCategoryExpenses: state.globalPosition.getIn(['expenses', 'expenses', 'currentPeriod', 'byCategory', 'ALL']),
        totalCategoryExpensesAll: state.globalPosition.getIn(['expenses', 'expenses']),
        totalCustomDatesAll: state.globalPosition.getIn(['expenses', 'expenses', 'currentPeriod', 'totalCustomDates', 'ALL'])
    }),
    dispatch => ({
        expensesActions: bindActionCreators(expensesActions, dispatch)
    })
)(ExpensesByCategoryViewOld));
